"use strict";

import angular from "angular";
import ngAnimate from "angular-animate";
import ngCookies from "angular-cookies";
import ngResource from "angular-resource";
import ngSanitize from "angular-sanitize";

import uiRouter from "angular-ui-router";
import uiBootstrap from "angular-ui-bootstrap";
import "angular-validation-match";

import { routeConfig } from "./app.config";

import _Auth from "../components/auth/auth.module";
import account from "./account";
import admin from "./admin";
import navbar from "../components/navbar/navbar.component";
import header from "../components/header/header.component";

import footer from "../components/footer/footer.component";
import main from "./main/main.component";
import users from "./users/users.component";
import operations from "./operations/operations.component";
import constants from "./app.constants";
import util from "../components/util/util.module";
import bodyDiagram from "./components/bodyDiagram/bodyDiagram.component";
import patientList from "./incident/patient/patientList/patientList.component";
import patientDetails from "./incident/patient/patientDetails/patientDetails.component";
import incidentConditions from "./incident/incidentConditions/incidentConditions.component";
import incidentLocation from "./incident/incidentLocation/incidentLocation.component";
import incidentDetails from "./incident/incidentDetails/incidentDetails.component";
import incidentAttachment from "./incident/incidentAttachment/incidentAttachment.component";
import incidentSharing from "./incident/incidentSharing/incidentSharing.component";

import incidentAvalanche from "./incident/incidentAvalanche/incidentAvalanche.component";
import incidentSnowImmersion from "./incident/incidentSnowImmersion/incidentSnowImmersion.component";
import incidentSkiAccident from "./incident/incidentSkiAccident/incidentSkiAccident.component";
import incidentCrevasse from "./incident/incidentCrevasse/incidentCrevasse.component";
import incidentHelicopter from "./incident/incidentHelicopter/incidentHelicopter.component";
import incidentVehicle from "./incident/incidentVehicle/incidentVehicle.component";
import incidentSnowcat from "./incident/incidentSnowcat/incidentSnowcat.component";
import incidentSnowmobile from "./incident/incidentSnowmobile/incidentSnowmobile.component";

import DashboardComponent from "./dashboard/dashboard.component";
import ExposureComponent from "./exposure/exposure.component";

import IncidentComponent from "./incident/incident.component";
import AddIncidentController from "./incident/addIncident.controller";
import AddPatientController from "./incident/patient/addPatient.controller";
import IncidentDetailController from "./dashboard/incidentDetail.controller";
import AddExposureController from "./exposure/addExposure.controller";
import AddUserController from "./users/addUser.controller";
import AddOperationController from "./operations/addOperation.controller";
import PatientDetailsPopupController from "./incident/patient/patientDetails/patientDetailsPopup.controller";

import Highcharts from "highcharts"; // eslint-disable-line no-unused-vars
import HighchartsNg from "highcharts-ng";
import moment from "angular-moment";
import uiselect from "ui-select"; // eslint-disable-line no-unused-vars

// import NgToast from 'ng-toast';

import "./app.scss";

angular
  .module("hccApp", [
    ngCookies,
    ngResource,
    ngSanitize,
    uiRouter,
    uiBootstrap,
    _Auth,
    account,
    admin,
    "validation.match",
    navbar,
    header,
    footer,
    main,
    users,
    operations,
    constants,
    bodyDiagram,
    patientList,
    patientDetails,
    incidentAvalanche,
    incidentSnowImmersion,
    incidentSkiAccident,
    incidentCrevasse,
    incidentHelicopter,
    incidentVehicle,
    incidentSnowcat,
    incidentSnowmobile,
    incidentConditions,
    incidentLocation,
    incidentDetails,
    incidentAttachment,
    incidentSharing,
    PatientDetailsPopupController,
    AddUserController,
    AddOperationController,
    util,
    DashboardComponent,
    ExposureComponent,
    IncidentComponent,
    AddIncidentController,
    AddPatientController,
    AddExposureController,
    IncidentDetailController,
    HighchartsNg,
    "angularFileUpload",
    "timePicker",
    "checklist-model",
    "ngToast",
    "ui.select",
    moment,
    ngAnimate
  ])
  .config(routeConfig)
  .config([
    "ngToastProvider",
    function(ngToastProvider) {
      ngToastProvider.configure({
        horizontalPosition: "right",
        verticalPosition: "bottom",
        animation: "slide"
        // additionalClasses: 'toast-message'
      });
    }
  ])
  .run(function($rootScope, $location, Auth) {
    "ngInject";
    // Redirect to login if route requires auth and you're not logged in
    $rootScope.$on("$stateChangeStart", function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path("/");
        }
      });
    });
  })

  .directive("onEnter", function() {
    var linkFn = function(scope, element, attrs) {
      element.bind("keypress", function(event) {
        if (event.which === 13) {
          scope.$apply(function() {
            scope.$eval(attrs.onEnter);
          });
          event.preventDefault();
        }
      });
    };

    return {
      link: linkFn
    };
  });

angular.element(document).ready(() => {
  angular.bootstrap(document, ["hccApp"], {
    strictDi: true
  });
});



// WEBPACK FOOTER //
// ./client/app/app.js